/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BusinessUnitTreeNodeExtendedDtoSortingRequestDto } from './BusinessUnitTreeNodeExtendedDtoSortingRequestDto';
import {
    BusinessUnitTreeNodeExtendedDtoSortingRequestDtoFromJSON,
    BusinessUnitTreeNodeExtendedDtoSortingRequestDtoFromJSONTyped,
    BusinessUnitTreeNodeExtendedDtoSortingRequestDtoToJSON,
    BusinessUnitTreeNodeExtendedDtoSortingRequestDtoToJSONTyped,
} from './BusinessUnitTreeNodeExtendedDtoSortingRequestDto';
import type { SearchRequestDto } from './SearchRequestDto';
import {
    SearchRequestDtoFromJSON,
    SearchRequestDtoFromJSONTyped,
    SearchRequestDtoToJSON,
    SearchRequestDtoToJSONTyped,
} from './SearchRequestDto';
import type { FilterRequestDto } from './FilterRequestDto';
import {
    FilterRequestDtoFromJSON,
    FilterRequestDtoFromJSONTyped,
    FilterRequestDtoToJSON,
    FilterRequestDtoToJSONTyped,
} from './FilterRequestDto';
import type { PagingRequestDto } from './PagingRequestDto';
import {
    PagingRequestDtoFromJSON,
    PagingRequestDtoFromJSONTyped,
    PagingRequestDtoToJSON,
    PagingRequestDtoToJSONTyped,
} from './PagingRequestDto';

/**
 * 
 * @export
 * @interface BusinessUnitTreeNodeExtendedDtoFilterSortSearchPagedRequestDto
 */
export interface BusinessUnitTreeNodeExtendedDtoFilterSortSearchPagedRequestDto {
    /**
     * 
     * @type {FilterRequestDto}
     * @memberof BusinessUnitTreeNodeExtendedDtoFilterSortSearchPagedRequestDto
     */
    filters?: FilterRequestDto;
    /**
     * 
     * @type {SearchRequestDto}
     * @memberof BusinessUnitTreeNodeExtendedDtoFilterSortSearchPagedRequestDto
     */
    search?: SearchRequestDto;
    /**
     * 
     * @type {PagingRequestDto}
     * @memberof BusinessUnitTreeNodeExtendedDtoFilterSortSearchPagedRequestDto
     */
    paging?: PagingRequestDto;
    /**
     * 
     * @type {BusinessUnitTreeNodeExtendedDtoSortingRequestDto}
     * @memberof BusinessUnitTreeNodeExtendedDtoFilterSortSearchPagedRequestDto
     */
    sorting?: BusinessUnitTreeNodeExtendedDtoSortingRequestDto;
}

/**
 * Check if a given object implements the BusinessUnitTreeNodeExtendedDtoFilterSortSearchPagedRequestDto interface.
 */
export function instanceOfBusinessUnitTreeNodeExtendedDtoFilterSortSearchPagedRequestDto(value: object): value is BusinessUnitTreeNodeExtendedDtoFilterSortSearchPagedRequestDto {
    return true;
}

export function BusinessUnitTreeNodeExtendedDtoFilterSortSearchPagedRequestDtoFromJSON(json: any): BusinessUnitTreeNodeExtendedDtoFilterSortSearchPagedRequestDto {
    return BusinessUnitTreeNodeExtendedDtoFilterSortSearchPagedRequestDtoFromJSONTyped(json, false);
}

export function BusinessUnitTreeNodeExtendedDtoFilterSortSearchPagedRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessUnitTreeNodeExtendedDtoFilterSortSearchPagedRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'filters': json['filters'] == null ? undefined : FilterRequestDtoFromJSON(json['filters']),
        'search': json['search'] == null ? undefined : SearchRequestDtoFromJSON(json['search']),
        'paging': json['paging'] == null ? undefined : PagingRequestDtoFromJSON(json['paging']),
        'sorting': json['sorting'] == null ? undefined : BusinessUnitTreeNodeExtendedDtoSortingRequestDtoFromJSON(json['sorting']),
    };
}

export function BusinessUnitTreeNodeExtendedDtoFilterSortSearchPagedRequestDtoToJSON(json: any): BusinessUnitTreeNodeExtendedDtoFilterSortSearchPagedRequestDto {
    return BusinessUnitTreeNodeExtendedDtoFilterSortSearchPagedRequestDtoToJSONTyped(json, false);
}

export function BusinessUnitTreeNodeExtendedDtoFilterSortSearchPagedRequestDtoToJSONTyped(value?: BusinessUnitTreeNodeExtendedDtoFilterSortSearchPagedRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'filters': FilterRequestDtoToJSON(value['filters']),
        'search': SearchRequestDtoToJSON(value['search']),
        'paging': PagingRequestDtoToJSON(value['paging']),
        'sorting': BusinessUnitTreeNodeExtendedDtoSortingRequestDtoToJSON(value['sorting']),
    };
}

